var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none",
    viewBox: "0 0 24 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.227 1.422c0-.471.382-.853.854-.853h16.151c.471 0 .853.382.853.853v4.322a.853.853 0 0 1-.853.853H1.081a.853.853 0 0 1-.854-.853zm1.707.853V4.89h14.445V2.275z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.38.853c0-.471.381-.853.852-.853h2.503c.47 0 .853.382.853.853v5.574a.853.853 0 0 1-.853.853h-2.503a.853.853 0 0 1-.853-.853zm1.705.853v3.867h.796V1.706zM0 8.929c0-.471.382-.853.853-.853H15.64c.47 0 .853.382.853.853V20.53a.853.853 0 0 1-.853.853H.853A.853.853 0 0 1 0 20.53zm1.706.853v9.896h13.08V9.782z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.924 4.891c.471 0 .853.382.853.853V8.93a.853.853 0 1 1-1.706 0V5.744c0-.471.382-.853.853-.853M11.431 4.891c.471 0 .853.382.853.853V8.93a.853.853 0 1 1-1.706 0V5.744c0-.471.382-.853.853-.853M14.787 12.682c0-.47.382-.853.853-.853h2.73c.47 0 .853.382.853.853v3.754a.853.853 0 0 1-.853.853h-2.73a.853.853 0 0 1-.853-.853zm1.706.854v2.047h1.024v-2.047z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.517 10.863c0-.472.381-.854.853-.854h2.502c.471 0 .853.382.853.854v7.28a.853.853 0 0 1-.853.852H18.37a.853.853 0 0 1-.853-.853zm1.706.853v5.573h.796v-5.573zM23.147 8.076c.471 0 .853.382.853.853v11.033a.853.853 0 0 1-1.706 0V8.929c0-.471.382-.853.853-.853",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.08 17.625a.853.853 0 0 1 1.195-.161l2.389 1.82a.853.853 0 0 1-1.034 1.357l-2.389-1.82a.853.853 0 0 1-.161-1.196M23.81 8.392a.853.853 0 0 1-.126 1.2l-2.389 1.934a.853.853 0 0 1-1.074-1.326l2.39-1.934a.853.853 0 0 1 1.199.126",
    clipRule: "evenodd"
  })));
};
export default SvgVideo;